import { Component } from "solid-js"
import { ArtworkItem } from "../Types";

type Props = {
    artwork: ArtworkItem;
}
export const Exhibiting : Component<Props> = (props) => {
    return (
        <>
        
        </>
    )
}